const Redirect = () => {
    window.location.assign('https://getitonyourstore.isadoramexicanfoods.com/');
    return (
        <>
        </>
    );
}

export default Redirect;